var map = {
	"./CommentCount.importable": [
		3215,
		983,
		889,
		215
	],
	"./DiscussionContainer.importable": [
		6916,
		983,
		889,
		680,
		891,
		916
	],
	"./DocumentBlockComponent.importable": [
		1053,
		983,
		53
	],
	"./EditionDropdown.importable": [
		6965,
		983,
		965
	],
	"./GetMatchStats.importable": [
		3639,
		983,
		889,
		639
	],
	"./InstagramBlockComponent.importable": [
		343,
		983,
		343
	],
	"./Links.importable": [
		588,
		983,
		889,
		924
	],
	"./MapEmbedBlockComponent.importable": [
		9641,
		983,
		754,
		641
	],
	"./MostViewedRightWrapper.importable": [
		5024,
		983,
		889,
		680,
		602
	],
	"./OnwardsLower.importable": [
		3213,
		983,
		889,
		213
	],
	"./OnwardsUpper.importable": [
		4999,
		983,
		889,
		752,
		999
	],
	"./RichLinkComponent.importable": [
		7051,
		983,
		889,
		51
	],
	"./SpotifyBlockComponent.importable": [
		9776,
		983,
		45,
		776
	],
	"./SubNav.importable": [
		6348,
		983,
		348
	],
	"./VineBlockComponent.importable": [
		8080,
		983,
		80
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8602;
module.exports = webpackAsyncContext;